import React from 'react';
import './App.css';
import DrumMachine from './components/DrumMachine';

const App = () => {
  return (
    <DrumMachine />
  );
}

export default App;
